import React from "react";
import { MenuItem, Typography } from "../material-old";
import { useAppDispatch, useAppSelector } from "../../redux/hooks.ts";
import { useNavigate } from "react-router-dom";
import { onLogout } from "../../redux/actions/authActions.tsx";
import {
  adminItems,
  validatedItems,
} from "./fixtures/sidebarProtectedItems.tsx";

interface Props {
  label: string;
  icon: React.ElementType;
  isLastItem: boolean;
  closeMenu: () => void;
  href: string;
}

export default function NavbarProfileItem({
  label,
  icon,
  isLastItem,
  closeMenu,
  href,
}: Props) {
  const dispatch = useAppDispatch();
  const { userInfo } = useAppSelector((state) => state.auth);
  const navigate = useNavigate();

  const onMenuItemClick = () => {
    if (href === "/auth/logout") dispatch(onLogout());

    navigate(href);
    closeMenu();
  };

  if (!userInfo?.groups.includes("admin") && adminItems.includes(href))
    return null;
  if (!userInfo?.is_validated && validatedItems.includes(href)) return null;

  return (
    <div>
      <MenuItem
        key={label}
        onClick={onMenuItemClick}
        className={`flex items-center gap-2 rounded ${
          isLastItem
            ? "hover:bg-red-500/10 focus:bg-red-500/10 active:bg-red-500/10"
            : ""
        }`}
      >
        {React.createElement(icon, {
          className: `h-4 w-4 ${isLastItem ? "text-red-500" : ""}`,
          strokeWidth: 2,
        })}
        <Typography
          as="span"
          variant="small"
          className="font-normal"
          color={isLastItem ? "red" : "inherit"}
        >
          {label}
        </Typography>
      </MenuItem>
    </div>
  );
}
